import * as mutationTypes from "./mutation-types";
import { getBlankRecord } from "./helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      levyCollectionId: null,
      data: [],
      loading: false,
      loaded: false
    },
    edit: {
      levyCollectionId: null,
      riskFactorId: null,
      data: getBlankRecord(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    create: {
      data: getBlankRecord(),
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "create"
      }
    },
    delete: {
      levyCollectionId: null,
      riskFactorId: null,
      processing: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "delete"
      }
    }
  };
}

export function getUnloadedState() {
  return {
    listing: { loaded: false }
  };
}
